export default {
    WELCOME: "Добро пожаловать",
    WORK_SPACE: "Пространство"
};
